// @ts-nocheck
import { httpClient } from '../../../core/network';

class AdobeCampaignService {
  static fetchCampaignEmails(userId, email) {
    const apiUrl = `/customers/${userId}/emails`;
    return httpClient.post(apiUrl, { email });
  }

  static fetchCampaignEmailsUrl(userId, email) {
    const apiUrl = `/customers/${userId}/emails/url`;
    return httpClient.post(apiUrl, {
      messageId: email.messageId,
      deliveryId: email.deliveryId,
    });
  }
}

export default AdobeCampaignService;
